import useRepeatableMetaData from '@v4/hooks/useRepeatableMetaData'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import useStyles from './Item.styled'

export const useItem = props => {
	const { group, itemKey, index } = props
	const metaData = useRepeatableMetaData({ group, index })
	const classes = useStyles(props)

	const { handleFocus: handleClick } = useFieldFocus({ metaData: { config: { group } }, index, itemKey })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.itemImage, index, itemKey })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.itemText, index, itemKey })

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.itemText,
		key: 'itemText',
		index,
	})

	return [
		{
			classes,
			image: metaData.itemImage,
			withImage: !!metaData.itemImage?.image,
			itemKey,
			group,

			text: metaData.itemText?.metaValue,
			textKey: metaData.itemText?.tierKey,
			textConfig: metaData.itemText?.config,
			textEditable,
		},
		{ handleImageClick, handleTextClick, handleClick, handleTextChange },
	]
}
